<div class="container">
  <!-- Filters Section - Hidden when used inside education-presentation -->
  <div class="d-flex gap-2" *ngIf="!hideFilters">
    <mat-form-field appearance="outline">
      <mat-label>Select Financial Year</mat-label>
      <mat-select [(ngModel)]="selectedYear" (selectionChange)="onYearChange($event)">
        <mat-option *ngFor="let year of [2023, 2024, 2025, 2026, 2027, 2028, 2029,2030]" [value]="year">
          {{ year }} - {{ year + 1 }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" [(ngModel)]="startDate">
        <input matEndDate placeholder="End date" [(ngModel)]="endDate">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline" hidden>
      <mat-label hidden>Select Centre</mat-label>
      <mat-select [(ngModel)]="selectedCentre">
        <mat-option value="All Centres" hidden>All Centres</mat-option>
        <mat-option *ngFor="let centre of uniqueCentres" [value]="centre">{{ centre }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Select Teacher</mat-label>
      <mat-select [(ngModel)]="selectedTeacher">
        <mat-option value="All Teachers">All Teachers</mat-option>
        <mat-option *ngFor="let teacher of uniqueTeachers" [value]="teacher">{{ teacher }}</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-mini-fab (click)="search()" permission="Edu. Session Count"
            [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab (click)="ClearAll()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <p *ngIf="!hideFilters">Note :- <span style="color:red">The financial year selection is only for auto-filling the date range.</span>
  </p>

  <!-- Teacher Filter - Always visible for fine-tuning -->
  <div class="d-flex gap-2 mb-3" *ngIf="hideFilters">
    <mat-form-field appearance="outline">
      <mat-label>Filter by Teacher</mat-label>
      <mat-select [(ngModel)]="selectedTeacher" (selectionChange)="search()">
        <mat-option value="All Teachers">All Teachers</mat-option>
        <mat-option *ngFor="let teacher of uniqueTeachers" [value]="teacher">{{ teacher }}</mat-option>
      </mat-select>
    </mat-form-field>
    <small class="text-muted align-self-center">Date range and centre controlled by parent filters</small>
  </div>

  <section>
    <div class="card p-2">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Individual Sessions</h2>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li>
            <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Edu. Session Count"
                 [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
              <img src="assets/images/icons/xlsx.png" alt=""/>
            </div>
          </li>
        </ul>
      </div>
      <div class="table-wrapper">
        <table class="table table-striped table-bordered" id="excel-table">
          <thead>
          <tr>
            <th scope="col">Individual Sessions</th>
            <th scope="col" *ngFor="let c of uniqueCentres">{{ c }}</th>
            <th scope="col">Total</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of tableData">
            <td>{{ data.teacher }}</td>
            <ng-container *ngFor="let centre of uniqueCentres">
              <td>{{ getCentreCount(data, centre) !== 0 ? getCentreCount(data, centre) : '-' }}</td>
            </ng-container>
            <td>{{ data.total }}</td>
          </tr>
          <tr>
            <td><strong>Total</strong></td>
            <ng-container *ngFor="let total of totalIndividualSessions">
              <td><strong>{{ total }}</strong></td>
            </ng-container>
            <td><strong>{{ grandTotalIndividualSessions }}</strong></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <section>
    <div class="card p-2">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Group Sessions</h2>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li>
            <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportGroupExcel()"
                 permission="Edu. Session Count" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
              <img src="assets/images/icons/xlsx.png" alt=""/>
            </div>
          </li>
        </ul>
      </div>
      <div class="table-wrapper">
      <table class="table table-striped table-bordered" id="group-excel-table">
        <thead>
        <tr>
          <th scope="col">Group Sessions</th>
          <th scope="col" *ngFor="let c of groupUniqueCentres">{{ c }}</th>
          <th scope="col">Total</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of groupTableData">
          <td>{{ data.teacher }}</td>
          <ng-container *ngFor="let centre of groupUniqueCentres">
            <td>{{ getCentreCount(data, centre) !== 0 ? getCentreCount(data, centre) : '-' }}</td>
          </ng-container>
          <td>{{ data.total }}</td>
        </tr>
        <tr>
          <td><strong>Total</strong></td>
          <ng-container *ngFor="let total of totalGroupSessions">
            <td><strong>{{ total }}</strong></td>
          </ng-container>
          <td><strong>{{ grandTotalGroupSessions }}</strong></td>
        </tr>
        </tbody>
      </table>
      </div>
    </div>
  </section>

  <!-- Volunteer Combined Sessions (Individual + Group) -->
  <section>
    <div class="card p-2">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Volunteer Sessions</h2>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li>
            <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportVolunteerSessionExcel()" permission="Edu. Session Count" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
              <img src="assets/images/icons/xlsx.png" alt="" />
            </div>
          </li>
        </ul>
      </div>

      <div class="table-wrapper">
        <table class="table table-striped table-bordered" id="volunteer-combined-table">
          <thead>
          <tr>
            <th scope="col">Volunteer</th>
            <th scope="col" *ngFor="let c of volunteerUniqueCentres">{{ c }}</th>
            <th scope="col">Total</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of volunteerCombinedTableData">
            <td>{{ data.teacher }}</td>
            <ng-container *ngFor="let centre of volunteerUniqueCentres">
              <td>{{ getCentreCount(data, centre) !== 0 ? getCentreCount(data, centre) : '-' }}</td>
            </ng-container>
            <td>{{ data.total }}</td>
          </tr>
          <tr>
            <td><strong>Total</strong></td>
            <ng-container *ngFor="let total of totalCombinedVolunteerSessions">
              <td><strong>{{ total }}</strong></td>
            </ng-container>
            <td><strong>{{ grandTotalCombinedVolunteerSessions }}</strong></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
  <section>
    <div class="card p-2">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Individual Sessions Below the age of 14</h2>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li>
            <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportBelowAgeSessionExcel()" permission="Edu. Session Count" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
              <img src="assets/images/icons/xlsx.png" alt="" />
            </div>
          </li>
        </ul>
      </div>

      <div class="table-wrapper">
        <table class="table table-striped table-bordered" id="excel-below-age-table">
          <thead>
          <tr>
            <th scope="col">Individual Sessions</th>
            <th scope="col" *ngFor="let c of uniqueCentres">{{c}}</th>
            <th scope="col">Total</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of ageBelowChildData">
            <td>{{ data.teacher }}</td>
            <ng-container *ngFor="let centre of uniqueCentres">
              <td>{{ getCentreCount(data, centre) !== 0 ? getCentreCount(data, centre) : '-' }}</td>
            </ng-container>
            <td>{{ data.total }}</td>
          </tr>
          <tr>
            <td><strong>Total</strong></td>
            <ng-container *ngFor="let total of totalIndividualBelowAgeSessions">
              <td><strong>{{ total }}</strong></td>
            </ng-container>
            <td><strong>{{ grandTotalIndividualBelowAgeSessions }}</strong></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
  <section>
    <div class="card p-2">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Individual Sessions Above the age of 14</h2>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li>
            <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportAboveAgeSessionExcel()" permission="Edu. Session Count" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
              <img src="assets/images/icons/xlsx.png" alt="" />
            </div>
          </li>
        </ul>
      </div>

      <div class="table-wrapper">
        <table class="table table-striped table-bordered" id="excel-above-age-table">
          <thead>
          <tr>
            <th scope="col">Individual Sessions</th>
            <th scope="col" *ngFor="let c of uniqueCentres">{{c}}</th>
            <th scope="col">Total</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of ageAboveChildData">
            <td>{{ data.teacher }}</td>
            <ng-container *ngFor="let centre of uniqueCentres">
              <td>{{ getCentreCount(data, centre) !== 0 ? getCentreCount(data, centre) : '-' }}</td>
            </ng-container>
            <td>{{ data.total }}</td>
          </tr>
          <tr>
            <td><strong>Total</strong></td>
            <ng-container *ngFor="let total of totalIndividualAboveAgeSessions">
              <td><strong>{{ total }}</strong></td>
            </ng-container>
            <td><strong>{{ grandTotalIndividualAboveAgeSessions }}</strong></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</div>
